import React, { useContext } from 'react';
import {  Team } from '../types';
import { TeamContext } from '../contexts/TeamContext';
import ManagerPastPlacements from './ManagerPastPlacements/ManagerPastPlacements';
import { Dropdown } from './UI/Dropdown';


const ManagerSummary: React.FC = () => {

    const teamContext = useContext(TeamContext);
    if (!teamContext) {
        throw new Error("LeagueStandings must be used within a TeamProvider");
    }

    const { teams, selectedTeamId, setSelectedTeamId } = teamContext;

    return (
        <div>

        
            {teams.length > 0 && (
                <div className="m-4">
                   <Dropdown<Team>
                                   id="team-select"
                                   label=""
                                   placeholder='Manager'
                                   options={teams}
                                   value={teams.find(t => String(t.teamId) === selectedTeamId)!}
                                   getOptionLabel={(team) => team.playerName}
                                   getOptionValue={(team) => team.teamId}
                                   onChange={(team) => setSelectedTeamId(String(team.teamId))}
                               />
                </div>
            )}

            {selectedTeamId && <ManagerPastPlacements managerId={selectedTeamId} />}
        </div>
    );


}


export default ManagerSummary;